<template>
  <p :style="style">
    <strong>
      {{ status ? 'Ativo' : 'Inativo' }}
    </strong>
  </p>
</template>

<script>
export default {
  name: 'AppStatusTag',
  props: {
    status: Boolean,
  },
  computed: {
    style() {
      return {
        fontSize: '0.85rem',
        width: '55px',
        heigth: '10px',
        color: 'white',
        textAlign: 'center',
        borderRadius: '3px',
        background: this.status ? '#689F38' : '#c02929',
      };
    },
  },
};
</script>

<style>
</style>